/* hs-eslint ignored failing-rules */

import { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import shallowCompare from 'react-addons-shallow-compare';
import { pick } from 'underscore';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { userInfoSync } from 'hub-http/userInfo';
import Routes from 'ContentUtils/Routes';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Select } from 'foundations-components/transitional/components/Select';
import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Small } from 'foundations-components/transitional/components/Small';
import Dimensions from 'ContentComponents/components/cmv2/media/Dimensions';
import SizingOptions from 'ContentComponents/components/cmv2/media/SizingOptions';
import CtaField from 'ContentComponents/components/cmv2/fields/Cta';
import FieldGroup from 'ContentComponents/components/cmv2/fields/FieldGroup';
import FormField from 'ContentComponents/components/cmv2/fields/Form';
import VideoBase from 'ContentComponents/components/cmv2/videoPicker/VideoBase';
import { calcDimensionsHeight, calcDimensionsWidth } from 'ContentComponents/components/cmv2/media/mediaHelpers';
import { getHubLVideoParamObjectFromFile } from 'FileManagerLib/utils/hubLVideo';
import PickersContext from 'ContentComponents/context/PickersContext';
import { ADVANCED_VIDEO_OPTIONS, HUBSPOT_VIDEO_2_TYPE } from 'ContentComponents/constants/VideoConstants';
import EditFormControl from 'ContentComponents/components/cmv2/EditFormControl';
import { pollForUploadedVideo } from 'ContentData/api/Videos';
import * as videoSelectors from 'ContentData/selectors/videos';
import * as videoActions from 'ContentData/actions/Videos';
import { ConversionAssetPositions, ConversionAssetTypes } from 'ContentUtils/enums/ConversionAssetTypes';
import MediaSizeTypes from 'ContentUtils/constants/MediaSizeTypes';
import { SUCCEEDED, FAILED, PENDING } from 'ContentUtils/constants/RequestStatus';
// @ts-expect-error no types yet
import ConversionAssetSummary from 'rich-text-lib/components/video/ConversionAssetSummary';
// @ts-expect-error no types yet
import ConversionAssetOptionsPanel from 'rich-text-lib/components/video/ConversionAssetOptionsPanel';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EVENT_TRACKING_KEYS = {
  CONVERSION_ASSET_TYPE: 'conversion-asset-type',
  VIDEO_ADD_NEW: 'video-add-new',
  VIDEO_CHANGE_MAX_SIZE: 'video-change-max-size',
  VIDEO_ADD_OVERLAY: 'select-form',
  VIDEO_MAX_SIZE: 'video-max-size',
  VIDEO_PQL_CLICK: 'video-pql-click'
};
const i18nKey = key => `ContentComponents.cmv2.fields.video.${key}`;
const EditDetailsFormControl = props => {
  const fileDetailsUrl = Routes.fileManager('', {
    section: 'subtitles',
    showDetails: props.fileId,
    source: 'video-field'
  });
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(Button, {
      "data-test-id": "cmv2-video-details-open",
      disabled: props.disabled,
      onClick: props.onClick,
      size: "extra-small",
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('details.buttonText')
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: fileDetailsUrl,
      paddingInlineStart: "300",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('details.manageSubtitles')
      })
    })]
  });
};
const mapStateToProps = (state, props) => {
  const {
    player_id: playerId
  } = props.value || {};
  return {
    video: videoSelectors.getVideo(state, {
      playerId
    }),
    videoFetchRequestStatus: videoSelectors.getVideoFetchStatus(state, {
      playerId
    })
  };
};
const mapDispatchToProps = {
  fetchVideoByPlayerId: videoActions.fetchVideoByPlayerId,
  saveVideo: videoActions.saveVideo
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class Video extends Component {
  constructor(props) {
    super(props);
    this.handleVideoSelect = this.handleVideoSelect.bind(this);
    this.onConversionAssetIdChange = this.onConversionAssetIdChange.bind(this);
    this.onDimensionChange = this.onDimensionChange.bind(this);
    this.onOverlayChange = this.onOverlayChange.bind(this);
    this.onPositionChange = this.onPositionChange.bind(this);
    this.onSaveComplete = this.onSaveComplete.bind(this);
    this.onSizeTypeChange = this.onSizeTypeChange.bind(this);
    this.onVideoDetailsPanelClose = this.onVideoDetailsPanelClose.bind(this);
    this.onVideoDetailsPanelOpen = this.onVideoDetailsPanelOpen.bind(this);
    this.onAdvancedOptionChange = this.onAdvancedOptionChange.bind(this);
    this.setAspectRatio = this.setAspectRatio.bind(this);
    this.openConversionAssetPanel = this.openConversionAssetPanel.bind(this);
    this.onSubmitConversionAssetPanel = this.onSubmitConversionAssetPanel.bind(this);
    this.onCloseConversionAssetPanel = this.onCloseConversionAssetPanel.bind(this);
    this.state = {
      conversionAssetPanelOpen: false,
      hasHubSpotVideoAccess: false,
      hasAdvancedLeadGenAccess: false,
      isAdvancedOptionsOpen: false,
      isConversionAssetsOpen: false,
      isVideoDetailsPanelOpen: false,
      pollingForVideo: false,
      posterUrl: null
    };
  }
  componentDidMount() {
    const {
      value
    } = this.props;
    if (value && value.player_id) {
      this.fetchVideoPlayer();
    }
    this.setAspectRatio(value);
    const {
      user
    } = userInfoSync();
    const hasHubSpotVideoAccess = user.scopes.includes('marketing-video');
    const hasAdvancedLeadGenAccess = user.scopes.includes('video-advanced-lead-gen');
    this.setState({
      hasAdvancedLeadGenAccess,
      hasHubSpotVideoAccess
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  componentDidUpdate(prevProps) {
    const {
      video,
      value
    } = this.props;
    const previousValue = prevProps.value || {};
    // can occur from dropping videos on widget placeholder in email editor in which case we don't have the video data on hand
    if (!video && value && value.player_type === HUBSPOT_VIDEO_2_TYPE && value.player_id && previousValue && previousValue.player_id !== value.player_id) {
      this.fetchVideoPlayer();
    }
  }
  get conversionAsset() {
    const {
      conversion_asset
    } = this.props.value || {};
    return conversion_asset || {};
  }
  get fieldKey() {
    const {
      fieldKey
    } = this.props;
    return fieldKey && fieldKey.join('.');
  }
  get readOnlyOrNoVideoAccess() {
    return this.props.readOnly || !this.state.hasHubSpotVideoAccess;
  }
  get videoConversionAssetOptions() {
    return Object.keys(ConversionAssetTypes).map(type => ({
      text: unescapedText(i18nKey(`overlayOptions.choices.${type}`)),
      value: type
    }));
  }
  get displayTimeOptions() {
    return Object.keys(ConversionAssetPositions).map(position => ({
      text: unescapedText(i18nKey(`displayTimeOptions.choices.${position}`)),
      value: ConversionAssetPositions[position]
    }));
  }
  setAspectRatio(value) {
    if (!value) return;
    const {
      width,
      height
    } = value;
    if (width && height) {
      this.aspectRatio = width / height;
    }
  }
  trackEvent(eventKey, options) {
    const {
      trackFieldAction
    } = this.props;
    if (trackFieldAction) {
      trackFieldAction(eventKey, options);
    }
  }
  fetchVideoPlayer() {
    const {
      fetchVideoByPlayerId,
      value = {}
    } = this.props;
    fetchVideoByPlayerId(value.player_id).catch(err => {
      throw err;
    });
  }
  onUpdateVideo(responseObj) {
    const {
      onFieldChange,
      saveVideo,
      value
    } = this.props;
    const valueParams = pick(getHubLVideoParamObjectFromFile(responseObj), ['player_id', 'height', 'width']);
    valueParams.player_type = HUBSPOT_VIDEO_2_TYPE;
    saveVideo(valueParams.player_id, responseObj);
    this.trackEvent(EVENT_TRACKING_KEYS.VIDEO_ADD_NEW);
    this.setAspectRatio(responseObj);
    onFieldChange(Object.assign({}, value, valueParams));
  }
  handleVideoSelect(response) {
    /* files are immutable, HS video 2.0 returns plain objects */
    const responseObj = response.toJS ? response.toJS() : response;
    if (response.toJS && responseObj.id) {
      pollForUploadedVideo(responseObj.id).then(videoObj => {
        this.onUpdateVideo(videoObj);
        this.setState({
          pollingForVideo: false
        });
      }).catch(err => {
        throw err;
      });
      this.setState({
        pollingForVideo: true
      });
    } else {
      this.onUpdateVideo(responseObj);
    }
  }
  onSaveComplete(updatedVideo) {
    const {
      saveVideo,
      value
    } = this.props;
    const {
      player_id
    } = value || {};
    /* files are immutable, v2 videos are plain objects */
    const video = updatedVideo.toJS ? updatedVideo.toJS() : updatedVideo;
    saveVideo(player_id, video);
    this.setState({
      isVideoDetailsPanelOpen: false,
      posterUrl: updatedVideo.posterUrl
    });
  }
  openConversionAssetPanel() {
    this.setState({
      conversionAssetPanelOpen: true
    });
  }
  onSubmitConversionAssetPanel(conversion_asset) {
    this.setState({
      conversionAssetPanelOpen: false
    });
    this.props.onFieldChange(Object.assign({}, this.props.value, {
      conversion_asset
    }));
  }
  onCloseConversionAssetPanel() {
    this.setState({
      conversionAssetPanelOpen: false
    });
  }
  onVideoDetailsPanelOpen() {
    this.setState({
      isVideoDetailsPanelOpen: true
    });
  }
  onVideoDetailsPanelClose() {
    this.setState({
      isVideoDetailsPanelOpen: false
    });
    this.fetchVideoPlayer();
  }
  onDimensionChange(e, calcDimensions) {
    const dimensionValue = e.target.value;
    const {
      onFieldChange,
      value
    } = this.props;
    const {
      size_type
    } = value || {};
    const isMax = size_type === MediaSizeTypes.AUTO_CUSTOM_MAX;
    const dimensions = calcDimensions(dimensionValue, this.aspectRatio, isMax);
    if (dimensions) {
      onFieldChange(Object.assign({}, value, dimensions));
    }
  }
  onOverlayChange(type) {
    const {
      onFieldChange,
      value
    } = this.props;
    if (type === ConversionAssetTypes.NONE) {
      onFieldChange(Object.assign({}, value, {
        conversion_asset: {
          type: null
        }
      }));
    } else {
      const action = type ? `video-select-${type.toLowerCase()}-overlay` : EVENT_TRACKING_KEYS.VIDEO_ADD_OVERLAY;
      this.trackEvent(action, {
        [EVENT_TRACKING_KEYS.CONVERSION_ASSET_TYPE]: type
      });
      onFieldChange(Object.assign({}, value, {
        conversion_asset: {
          type,
          id: null,
          position: this.conversionAsset.position || ConversionAssetPositions.PRE
        }
      }));
    }
  }
  onPositionChange(position) {
    const {
      onFieldChange,
      value
    } = this.props;
    onFieldChange(Object.assign({}, value, {
      conversion_asset: Object.assign({}, this.conversionAsset, {
        position
      })
    }));
  }
  onConversionAssetIdChange(id) {
    const {
      onFieldChange,
      value
    } = this.props;
    onFieldChange(Object.assign({}, value, {
      conversion_asset: Object.assign({}, this.conversionAsset, {
        id
      })
    }));
  }
  onSizeTypeChange(e) {
    const {
      onFieldChange,
      value
    } = this.props;
    this.trackEvent(EVENT_TRACKING_KEYS.VIDEO_CHANGE_MAX_SIZE, {
      [EVENT_TRACKING_KEYS.VIDEO_MAX_SIZE]: e.target.value
    });
    onFieldChange(Object.assign({}, value, {
      size_type: e.target.value
    }));
  }
  onAdvancedOptionChange(evt, advancedOption) {
    const {
      onFieldChange,
      value
    } = this.props;
    onFieldChange(Object.assign({}, value, {
      [advancedOption]: evt.target.checked
    }));
    this.trackEvent(`video-${advancedOption}-${evt.target.checked ? 'enabled' : 'disabled'}`);
  }
  renderConversionAssets() {
    const {
      fieldKey,
      flush,
      isInEmail,
      useOnDark,
      video,
      show_conversion_assets: showConversionAssets
    } = this.props;
    const {
      isConversionAssetsOpen
    } = this.state;
    if (isInEmail || !video || !showConversionAssets) return null;
    return /*#__PURE__*/_jsx(FieldGroup, {
      "data-test-id": "cmv2-video-conversion-assets",
      containsNestedGroups: false,
      fieldGroupOpen: isConversionAssetsOpen,
      fieldKey: fieldKey ? fieldKey.concat(['conversion-assets']) : [],
      onFieldGroupOpenChange: () => this.setState({
        isConversionAssetsOpen: !isConversionAssetsOpen
      }),
      onFieldReset: () => {},
      label: unescapedText(i18nKey(`overlayOptions.expandableLabel`)),
      stretchToSides: !flush,
      useOnDark: useOnDark,
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`overlayOptions.header.labelAdvanced`)
        }),
        paddingInline: "600",
        paddingBlockStart: "200",
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Select, {
            onChange: evt => this.onOverlayChange(evt.target.value),
            options: this.videoConversionAssetOptions,
            disabled: this.readOnlyOrNoVideoAccess,
            value: this.conversionAsset.type || ConversionAssetTypes.NONE
          }), this.renderContentPicker(), this.renderDisplayTimeOptions()]
        })
      })
    });
  }
  renderDisplayTimeOptions() {
    const conversionAsset = this.conversionAsset;
    if (!conversionAsset.type || conversionAsset.type === ConversionAssetTypes.NONE) {
      return null;
    }
    if (this.state.hasAdvancedLeadGenAccess) {
      if (!conversionAsset.id) {
        return null;
      }
      return /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "200",
        as: "div",
        children: [/*#__PURE__*/_jsx(EditFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`displayTimeOptions.header.labelAdvanced`)
          }),
          labelItemRight: /*#__PURE__*/_jsx(Button, {
            size: "sm",
            use: "link",
            onClick: this.openConversionAssetPanel,
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('displayTimeOptions.editButtonText')
              })
            })
          }),
          children: /*#__PURE__*/_jsx(ConversionAssetSummary, {
            conversionAsset: conversionAsset
          })
        }), this.state.conversionAssetPanelOpen && /*#__PURE__*/_jsx(ConversionAssetOptionsPanel, {
          conversionAsset: conversionAsset,
          video: this.props.video,
          onSubmit: this.onSubmitConversionAssetPanel,
          onClose: this.onCloseConversionAssetPanel,
          trackVideoInteraction: this.props.trackFieldAction
        })]
      });
    }
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`displayTimeOptions.header.label`)
        }),
        children: /*#__PURE__*/_jsx(Select, {
          onChange: evt => this.onPositionChange(evt.target.value),
          options: this.displayTimeOptions,
          disabled: this.readOnlyOrNoVideoAccess,
          value: conversionAsset.position || ConversionAssetPositions.PRE
        })
      })
    });
  }
  renderContentPicker() {
    const conversionAsset = this.conversionAsset;
    if (!conversionAsset.type || conversionAsset.type === ConversionAssetTypes.NONE) {
      return null;
    }
    switch (conversionAsset.type) {
      case ConversionAssetTypes.CTA:
        {
          return /*#__PURE__*/_jsx(CtaField, {
            isVideo: true,
            includeVideoCtas: true,
            label: unescapedText(i18nKey('overlayOptions.choices.CTA')),
            onFieldChange: id => {
              this.onConversionAssetIdChange(id);
              this.trackEvent(id ? 'video-select-cta' : 'video-remove-cta');
            },
            readOnly: this.readOnlyOrNoVideoAccess,
            value: conversionAsset.id
          });
        }
      case ConversionAssetTypes.FORM:
        {
          return /*#__PURE__*/_jsx(FormControl, {
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(`overlayOptions.choices.FORM`)
            }),
            children: /*#__PURE__*/_jsx(FormField, {
              componentsByType: this.props.componentsByType,
              allowFormEditing: false,
              forVideo: true,
              readOnly: this.readOnlyOrNoVideoAccess,
              required: false,
              value: {
                form_id: conversionAsset.id
              },
              onFieldChange: ({
                form_id
              } = {}) => {
                if (form_id !== conversionAsset.id) {
                  this.onConversionAssetIdChange(form_id);
                }
              },
              onRedirect: this.props.onRedirect,
              setFieldKey: this.props.setFieldKey,
              trackFormAction: (action, options) => {
                this.trackEvent(`video-${action}`, options);
              }
            })
          });
        }
      default:
        return null;
    }
  }
  renderDimensions() {
    const {
      useOnDark,
      value,
      maxContainerWidth
    } = this.props;
    const {
      height,
      max_height,
      max_width,
      size_type,
      width
    } = value || {};
    let maxProps = {};
    let renderedWidth = width;
    let renderedHeight = height;
    let heightLabel = i18nKey('sizing.sizeType.heightLabel');
    let heightKey = 'height';
    let widthLabel = i18nKey('sizing.sizeType.widthLabel');
    let widthKey = 'width';
    if (size_type === MediaSizeTypes.AUTO_CUSTOM_MAX) {
      renderedHeight = max_height > 0 ? max_height : height;
      renderedWidth = max_width > 0 ? max_width : width;
      heightLabel = i18nKey('sizing.maxSizeType.heightLabel');
      heightKey = 'maxHeight';
      widthLabel = i18nKey('sizing.maxSizeType.widthLabel');
      widthKey = 'maxWidth';
    }
    if (maxContainerWidth) {
      const maxContainerHeight = Math.round(maxContainerWidth / this.aspectRatio);
      maxProps = {
        maxHeight: maxContainerHeight,
        maxWidth: maxContainerWidth
      };
    }
    return /*#__PURE__*/_jsx(Dimensions, Object.assign({
      height: renderedHeight,
      heightLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: heightLabel
      }),
      heightSeleniumKey: `${this.fieldKey}:${heightKey}`,
      onHeightChange: e => this.onDimensionChange(e, calcDimensionsHeight),
      onWidthChange: e => this.onDimensionChange(e, calcDimensionsWidth),
      readOnly: this.readOnlyOrNoVideoAccess,
      useOnDark: useOnDark,
      width: renderedWidth,
      widthLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: widthLabel
      }),
      widthSeleniumKey: `${this.fieldKey}:${widthKey}`
    }, maxProps));
  }
  renderSizingOptions() {
    const {
      isInEmail,
      resizable,
      useOnDark,
      value,
      video
    } = this.props;
    const {
      size_type
    } = value || {};
    if (!video || !resizable) return null;
    if (isInEmail) {
      return this.renderDimensions();
    }
    const tooltipLink = /*#__PURE__*/_jsx(Link, {
      external: true,
      href: "https://knowledge.hubspot.com/cos-general/how-will-my-hubspot-content-appear-on-a-mobile-device",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('sizing.maxSizeType.tooltipLink')
      })
    });
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(SizingOptions, {
        fieldKey: this.fieldKey,
        fullWidthHelpText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('sizing.maxSizeType.options.fullWidthTooltip')
        }),
        isFullWidthSizingEnabled: true,
        maxSizeTooltip: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('sizing.maxSizeType.tooltip'),
          options: {
            tooltipLink
          }
        }),
        onChange: this.onSizeTypeChange,
        readOnly: this.readOnlyOrNoVideoAccess,
        sizeType: size_type,
        useOnDark: useOnDark
      }), value && value.size_type === MediaSizeTypes.AUTO_CUSTOM_MAX && this.renderDimensions()]
    });
  }
  renderDetailsPanel() {
    const {
      player_id
    } = this.props.value || {};
    if (!this.state.isVideoDetailsPanelOpen) {
      return null;
    }
    return /*#__PURE__*/_jsx(PickersContext.Consumer, {
      children: ({
        HubSpotVideoPicker
      }) => {
        if (!HubSpotVideoPicker) {
          throw new Error('Missing required HubSpotVideoPicker PickerComponent');
        }
        return /*#__PURE__*/_jsx(HubSpotVideoPicker, {
          editingVideoId: player_id,
          onClose: this.onVideoDetailsPanelClose,
          onSelect: this.onSaveComplete
        });
      }
    });
  }
  renderVideoDetails() {
    const {
      video
    } = this.props;
    if (!video) {
      return null;
    }
    const tooltipLink = /*#__PURE__*/_jsx(Link, {
      external: true,
      href: "https://knowledge.hubspot.com/integrations/use-video-in-hubspot#add-video-to-your-content",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('details.tooltipLink')
      })
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`details.label`)
        }),
        tooltip: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('details.tooltip'),
          options: {
            tooltipLink
          }
        }),
        children: /*#__PURE__*/_jsx(EditDetailsFormControl, {
          disabled: this.readOnlyOrNoVideoAccess,
          onClick: this.onVideoDetailsPanelOpen,
          fileId: video.sourceFileId
        })
      }), this.renderDetailsPanel()]
    });
  }
  renderMissingScopeAlert() {
    if (this.state.hasHubSpotVideoAccess) return null;
    const upgradeLink = /*#__PURE__*/_jsx(Link, {
      external: true,
      href: Routes.marketingHubPricingPage(),
      onClick: () => {
        this.trackEvent(EVENT_TRACKING_KEYS.VIDEO_PQL_CLICK);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`missingScope.upgradeLinkText`)
      })
    });
    return /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`missingScope.title`)
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey(`missingScope.message`),
        options: {
          upgradeLink
        }
      })
    });
  }
  renderAdvancedOptions() {
    const {
      fieldKey,
      flush,
      isInEmail,
      readOnly,
      show_advanced_options: showAdvancedOptions,
      useOnDark,
      value,
      video
    } = this.props;
    const {
      isAdvancedOptionsOpen
    } = this.state;
    if (isInEmail || !video || !showAdvancedOptions) {
      return null;
    }
    return /*#__PURE__*/_jsx(FieldGroup, {
      "data-test-id": "cmv2-video-advanced-options",
      containsNestedGroups: false,
      fieldGroupOpen: isAdvancedOptionsOpen,
      fieldKey: fieldKey ? fieldKey.concat(['advanced-options']) : [],
      onFieldGroupOpenChange: () => this.setState({
        isAdvancedOptionsOpen: !isAdvancedOptionsOpen
      }),
      onFieldReset: () => {},
      label: unescapedText(i18nKey(`advancedOptions.expandableLabel`)),
      stretchToSides: !flush,
      useOnDark: useOnDark,
      children: /*#__PURE__*/_jsx(View, {
        paddingInline: "600",
        paddingBlockStart: "600",
        as: "div",
        children: Object.keys(ADVANCED_VIDEO_OPTIONS).map(advancedOptionKey => {
          const advancedOption = ADVANCED_VIDEO_OPTIONS[advancedOptionKey];
          const checked = value && value[advancedOption];
          return /*#__PURE__*/_jsx(Checkbox, {
            checked: checked,
            onChange: e => this.onAdvancedOptionChange(e, advancedOption),
            readOnly: readOnly,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(`advancedOptions.${advancedOption}`)
            })
          }, advancedOption);
        })
      })
    });
  }
  renderNotEmbeddableAlert() {
    const {
      video
    } = this.props;
    return /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('nonEnbeddableVideo2.title')
      }),
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: i18nKey('nonEnbeddableVideo2.message'),
        options: {
          allowEmbeddingLink: /*#__PURE__*/_jsx(Link, {
            external: true,
            href: Routes.fileManager('', {
              showDetails: video.sourceFileId || video.id,
              source: 'video-field'
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('nonEnbeddableVideo2.allowEmbeddingLink')
            })
          })
        }
      })
    });
  }
  render() {
    const {
      fieldKey,
      help_text: helpText,
      inline_help_text: inlineHelpText,
      label,
      onFieldChange,
      readOnly,
      required,
      show_preview,
      useOnDark,
      value,
      video,
      videoFetchRequestStatus
    } = this.props;
    const {
      hasHubSpotVideoAccess,
      pollingForVideo
    } = this.state;
    const {
      player_id: playerId
    } = value || {};
    const videoFetchFailed = !!(playerId && (videoFetchRequestStatus === FAILED || videoFetchRequestStatus === SUCCEEDED && !video));
    if (!hasHubSpotVideoAccess && (!playerId || videoFetchFailed)) {
      return /*#__PURE__*/_jsx(EditFormControl, {
        label: label,
        required: required,
        helpText: helpText,
        inlineHelpText: inlineHelpText,
        children: this.renderMissingScopeAlert()
      });
    }
    let videoIsUnembeddable = false;
    if (playerId && video) {
      videoIsUnembeddable = !video.isEmbeddable;
    }
    const videoWasDeleted = !!(playerId && video && (video.deleted_at || video.deletedAt));
    let alert = null;
    if (!hasHubSpotVideoAccess) {
      alert = this.renderMissingScopeAlert();
    } else if (videoIsUnembeddable) {
      alert = this.renderNotEmbeddableAlert();
    } else if (videoWasDeleted) {
      alert = /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('deletedVideo.title')
        }),
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('deletedVideo.message')
        })
      });
    } else if (videoFetchFailed) {
      alert = /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('videoFetchFailed.title')
        }),
        type: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('videoFetchFailed.message')
        })
      });
    }
    const maybeConversionAssets = this.renderConversionAssets();
    const maybeAdvancedOptions = this.renderAdvancedOptions();
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [alert, /*#__PURE__*/_jsx(VideoBase, {
        fieldKey: fieldKey,
        handleVideoSelect: this.handleVideoSelect,
        hasHubSpotVideoAccess: hasHubSpotVideoAccess,
        helpText: helpText,
        inlineHelpText: inlineHelpText,
        label: label,
        onFieldChange: onFieldChange,
        isLoading: videoFetchRequestStatus === PENDING || pollingForVideo,
        posterUrl: this.state.posterUrl,
        readOnly: readOnly,
        required: required,
        showPreview: show_preview,
        useOnDark: useOnDark,
        value: value,
        videoData: video
      }), !(videoIsUnembeddable || videoWasDeleted || videoFetchFailed) && /*#__PURE__*/_jsxs(Fragment, {
        children: [this.renderSizingOptions(), this.renderVideoDetails(), maybeConversionAssets || maybeAdvancedOptions ? /*#__PURE__*/_jsxs(View, {
          marginBlockStart: "600",
          as: "div",
          children: [maybeConversionAssets, maybeAdvancedOptions]
        }) : null]
      })]
    });
  }
}
Video.defaultProps = {
  fieldKey: [],
  resizable: true,
  show_advanced_options: false,
  show_conversion_assets: true,
  show_preview: true,
  value: {},
  label: ''
};
export default connector(Video);